var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`input-top-tip input-top-tip-${_vm.id}`},[_vm._t("default"),(_vm.visible)?_c('label',{staticClass:"input-label",style:({ top: _vm.top + 'px', height: _vm.height + 'px', zoom: _vm.zoom })},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }